<template>
  <order-location :order="order"></order-location>
</template>

<script>

import OrderLocation from "@/modules/delivery/components/OrderLocation/OrderLocation.vue";

export default {
  name: "ShowOrderLocation",
  components: {OrderLocation},
  props: {
    order: {type: Object}
  },

}
</script>

<style scoped>

</style>
